import { Flex, Skeleton, Typography } from "antd";
import { observer } from "mobx-react-lite";

import { PlateList, PlateItem } from "components/PlateList";
import { useStores } from "stores";
import { getColumns } from "./getColumns";
import { CountBadge, WhiteBoxBlock } from "ui";
import { BidWalletCheckGridDto, RISK_STATUS_ENUM } from "interfaces";
import { BidWalletCheckList } from "stores/BidWalletCheckList";
import { ReactComponent as InfoIcon } from "images/info.svg";
import { ApproveWalletCheckButton } from "components";
import { useMemo } from "react";
import { WalletFooter } from "./WalletFooter";
interface IProps {
  onWalletChecksUpdated: () => Promise<void>;
}

export const WalletCheckList = observer(({ onWalletChecksUpdated }: IProps) => {
  const { bidWalletChecks, bidCard, user } = useStores();

  const count = bidWalletChecks.allData.length ?? 0;

  const columns = useMemo(() => {
    return getColumns(bidWalletChecks, bidCard.bid);
  }, [count, bidCard.bid]);

  return (
    <WhiteBoxBlock
      collapse={{
        title: (
          <Flex justify="space-between" align="center">
            <Flex gap={4} align="center">
              <Typography.Text className="whitebox-title">Проверки кошельков</Typography.Text>
              {count > 0 && <CountBadge count={count} />}
            </Flex>
          </Flex>
        ),
        defaultOpen: true,
      }}
    >
      <Flex vertical gap="large">
        {bidWalletChecks.fetchStatus === "fetching" ? (
          <Skeleton active />
        ) : (
          <PlateList<BidWalletCheckGridDto, BidWalletCheckList>
            store={bidWalletChecks}
            columns={columns}
            PlateComponent={PlateItem}
            updateWithInterval
            emptyProps={{
              description: "Проверки кошельков не найдены",
            }}
            errorMessage="Ошибка загрузки проверок кошельков"
            showPagination
            footerItemComponent={(item) => <WalletFooter item={item} onWalletChecksUpdated={onWalletChecksUpdated} />}
          />
        )}
      </Flex>
    </WhiteBoxBlock>
  );
});
